import React from "react";
import Header from "./Header";
import Footer from "./Footer";
import "../css/terms.scss";

function Terms() {
  return (
    <div className="terms">
      <Header />
      <main role="main" id="MainContent" tabIndex={-1}>
        <div id="shopify-section-terms-main" className="shopify-section">
          <div className="page-width">
            <div className="page-width__inner">
              <h1 className="main-page__header">Terms of Service</h1>
              <div className="main-page">
                <div className="main-page__content prose is-page">
                  <div className="wrapper">
                    <div className="grid">
                      <p>&nbsp;</p>
                    </div>
                    <p>
                      Thanks for visiting our site. The short version is: play
                      nice, respect our stuff, and know the limits below. The
                      full version follows.
                    </p>
                    <p>&nbsp;</p>
                    <p style={{ textAlign: "center" }}>
                      <strong>ENZIROT LIMITED Terms of Service</strong>
                    </p>
                    <p style={{ textAlign: "center" }}>
                      <strong>Last Updated 4-9-2026</strong>
                    </p>
                    <p>
                      These Terms of Service (“Terms”) govern your access to and
                      use of the website and online services (collectively, the
                      “Services”) offered by ENZIROT LIMITED (“mvandora,”
                      “we,” “us,” or “our”), including browsing, purchasing
                      products, creating an account, and interacting with our
                      content. By accessing or using the Services, you agree to
                      be bound by these Terms and our Privacy Policy. If you do
                      not agree, please do not use the Services.
                    </p>
                    <p>&nbsp;</p>
                    <p>
                      <strong>Eligibility &amp; Accounts:</strong>
                    </p>
                    <p>
                      You must be at least the age of majority in your place of
                      residence to make a purchase. If you create an account,
                      you agree to provide accurate information and to keep your
                      login credentials confidential. You are responsible for
                      all activity under your account. Notify us promptly if you
                      suspect unauthorized access.
                    </p>
                    <p>&nbsp;</p>
                    <p>
                      <strong>Products, Pricing &amp; Availability:</strong>
                    </p>
                    <p>
                      We strive to display our products and prices accurately.
                      However, occasional errors may occur (including
                      descriptions, pricing, or availability). We reserve the
                      right to correct errors, cancel orders placed at an
                      incorrect price, or limit quantities—even after an order
                      is submitted—where permitted by law. Colors and textures
                      may vary slightly by screen or device.
                    </p>
                    <p>&nbsp;</p>
                    <p>
                      <strong>Orders &amp; Payment:</strong>
                    </p>
                    <p>
                      When you place an order, you offer to purchase the items
                      in your cart at the prices shown, plus applicable taxes
                      and shipping. We may refuse or cancel any order for any
                      lawful reason, including suspected fraud, inventory
                      limits, or payment issues. You authorize us and our
                      payment processors to charge your selected payment method
                      for the total amount due.
                    </p>
                    <p>&nbsp;</p>
                    <p>
                      <strong>Shipping &amp; Returns:</strong>
                    </p>
                    <p>
                      Shipping options, timelines, and fees are described in our
                      Shipping Info. Return and exchange rules are set forth in
                      our Returns &amp; Exchanges policy. Those policies are
                      incorporated into these Terms by reference.
                    </p>
                    <p>&nbsp;</p>
                    <p>
                      <strong>Intellectual Property:</strong>
                    </p>
                    <p>
                      All content on the Services—including text, graphics,
                      logos, images, product photography, videos, and
                      software—is owned by mvandora or our licensors and is
                      protected by copyright, trademark, and other laws. You may
                      not copy, modify, distribute, sell, or create derivative
                      works from our content without prior written permission,
                      except as allowed by law for personal, non-commercial use
                      (such as saving a page to shop later).
                    </p>
                    <p>&nbsp;</p>
                    <p>
                      <strong>Prohibited Conduct:</strong>
                    </p>
                    <p>
                      You agree not to misuse the Services. For example, you
                      must not: interfere with or disrupt the site; attempt
                      unauthorized access to our systems or other users’
                      accounts; use automated means to scrape or harvest data in
                      violation of these Terms; transmit viruses or harmful
                      code; or use the Services for any unlawful, fraudulent, or
                      abusive purpose.
                    </p>
                    <p>&nbsp;</p>
                    <p>
                      <strong>Disclaimer of Warranties:</strong>
                    </p>
                    <p>
                      THE SERVICES AND ALL CONTENT ARE PROVIDED “AS IS” AND “AS
                      AVAILABLE,” WITHOUT WARRANTIES OF ANY KIND, WHETHER
                      EXPRESS OR IMPLIED, INCLUDING MERCHANTABILITY, FITNESS FOR
                      A PARTICULAR PURPOSE, AND NON-INFRINGEMENT, TO THE FULLEST
                      EXTENT PERMITTED BY LAW.
                    </p>
                    <p>&nbsp;</p>
                    <p>
                      <strong>Limitation of Liability:</strong>
                    </p>
                    <p>
                      TO THE FULLEST EXTENT PERMITTED BY LAW, mvandora AND
                      OUR AFFILIATES, OFFICERS, DIRECTORS, EMPLOYEES, AND AGENTS
                      WILL NOT BE LIABLE FOR ANY INDIRECT, INCIDENTAL, SPECIAL,
                      CONSEQUENTIAL, OR PUNITIVE DAMAGES, OR ANY LOSS OF
                      PROFITS, DATA, OR GOODWILL, ARISING FROM YOUR USE OF THE
                      SERVICES OR PRODUCTS, EVEN IF WE HAVE BEEN ADVISED OF THE
                      POSSIBILITY OF SUCH DAMAGES. OUR TOTAL LIABILITY FOR ANY
                      CLAIM ARISING OUT OF OR RELATING TO THESE TERMS OR THE
                      SERVICES SHALL NOT EXCEED THE GREATER OF (A) THE AMOUNT
                      YOU PAID TO US FOR THE PRODUCT OR ORDER GIVING RISE TO THE
                      CLAIM IN THE SIX (6) MONTHS BEFORE THE CLAIM, OR (B) ONE
                      HUNDRED POUNDS (£100), EXCEPT WHERE PROHIBITED BY LAW.
                    </p>
                    <p>&nbsp;</p>
                    <p>
                      <strong>Indemnification:</strong>
                    </p>
                    <p>
                      You agree to defend, indemnify, and hold harmless ENZIROT
                      LIMITED and our affiliates from any claims, damages, losses,
                      or expenses (including reasonable attorneys’ fees) arising
                      from your use of the Services, your violation of these
                      Terms, or your violation of any third-party rights.
                    </p>
                    <p>&nbsp;</p>
                    <p>
                      <strong>Governing Law &amp; Disputes:</strong>
                    </p>
                    <p>
                      These Terms are governed by the laws of England and Wales,
                      without regard to conflict-of-law principles. The courts
                      of England and Wales shall have jurisdiction over disputes
                      arising out of these Terms or the Services, unless a
                      different forum is required by applicable consumer
                      protection law in your jurisdiction.
                    </p>
                    <p>&nbsp;</p>
                    <p>
                      <strong>Changes to These Terms:</strong>
                    </p>
                    <p>
                      We may update these Terms from time to time. If we make
                      material changes, we will post the updated Terms on this
                      page and update the “Last Updated” date. Your continued
                      use of the Services after changes become effective
                      constitutes your acceptance of the revised Terms.
                    </p>
                    <p>&nbsp;</p>
                    <p>
                      <strong>Contact:</strong>
                    </p>
                    <p>
                      Questions about these Terms? Email us at{" "}
                      <a href="mailto:buyer@mvandora.store">
                        buyer@mvandora.store
                      </a>{" "}
                      or write to:
                    </p>
                    <p>
                      ENZIROT LIMITED<br />
                      291597 OFFICE SUITE 29A, 3/F 23 WHARF STREET, LONDON,
                      ENGLAND SE8 3GG<br />
                      Website: <a href="https://mvandora.store">mvandora.store</a>
                    </p>
                    <p>&nbsp;</p>
                    <div className="grid" />
                    <div className="grid">
                      <p style={{ textAlign: "center" }}>&nbsp;</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <limespot />
      </main>

      <Footer />
    </div>
  );
}

export default Terms;
